// Attachments are fetched with the bearer token and opened as blob: URLs. A blob URL keeps the Content-Type it
// was created with and a top-level blob: document runs in THIS app's origin (where the login token lives), so an
// attachment typed text/html or image/svg+xml, opened in a tab, is the sender's script running with the viewer's
// session. The server already serves such files as application/octet-stream (backend safe_media.py); this is the
// second line, so no consumer of these fetchers can ever hold a blob that renders active content.
const SAFE_BLOB_TYPES = new Set([
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/bmp",
  "application/pdf",
]);

export const OPAQUE_BLOB_TYPE = "application/octet-stream";

export function isSafeBlobType(type) {
  return SAFE_BLOB_TYPES.has(String(type || "").split(";", 1)[0].trim().toLowerCase());
}

export function safeBlob(blob) {
  if (!blob || isSafeBlobType(blob.type)) return blob;
  return new Blob([blob], { type: OPAQUE_BLOB_TYPE });
}
